import React, { createContext, useContext, useState } from "react";

const CustomerContext = createContext();

export const CustomerProvider = ({ children }) => {
  const [addressId,setAddressId]=useState()
  const[activeTabLabel,setActiveTabLabel]=useState()

  return (
    <CustomerContext.Provider value={{ addressId, setAddressId,activeTabLabel,setActiveTabLabel }}>
      {children}
    </CustomerContext.Provider>
  );
};

export const useCustomer= () => useContext(CustomerContext);
